/// <reference path="../../typings/index.d.ts"/>

import * as React from "react";
import { PropTypes } from "react";
import { Button } from '../components/Button';
import { Socialbar } from '../components/Socialbar';

export interface TopbarProps extends React.Props<Topbar> {
    toggleLogin: any;
}

export interface TopbarState {
    session?: string;
    email?: string;
}

export class Topbar extends React.Component<TopbarProps, TopbarState> {
    constructor(props: TopbarProps) {
        super(props);

        this.state = {
            session: null,
            email: null
        }
    }

    public render() {
        // <Socialbar className="topbar__socialbar"/>
        return (
            <div className="topbar">
                <img className="topbar__logo" src="images/logo.png" />
                <div className="topbar__type">lapface</div>
                <div className="topbar__divider" />
                <div className="topbar__tagline">laptop work buddies</div>
                <Button className="topbar__button_activate secondary"
                    caption="Broadcast panel"
                    onClick={this.props.toggleLogin}
                />
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Topbar.tsx
 **/